import { render, staticRenderFns } from "./LeagueTeamUser.vue?vue&type=template&id=20c8644c"
import script from "./LeagueTeamUser.vue?vue&type=script&lang=js"
export * from "./LeagueTeamUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports